import { Injectable } from '@angular/core';

/** Service para trabalhar com a biblioteca DataTables */
@Injectable({
    providedIn: 'root'
})
export class DataTablesService {

    constructor() {
        // Configuração default das DataTables
        const fn = jQuery.fn as any;
        jQuery.extend(fn.dataTable.defaults, {
            lengthChange: false,
            pagingType: 'full_numbers',
            pageLength: 15,
            order: [[1, 'asc']],
            columnDefs: [
                {orderable: false, targets: 0}
            ],
            language: {url: './assets/scripts/datatables/datatable.pt-br.json'}
        });
    }


    /**
     * Executa a biblioteca DataTables
     */
    showTable(selector: any, dataTable?: any, options: any = {}): Promise<any> {
        return new Promise<any>((resolve) => {
            // Se tiver sido passada a dataTable, então destruimos ela para criá-la novamente
            if (dataTable) {
                this.destroyTable(dataTable);
            }

            setTimeout(() => {
                const newDataTable = jQuery(selector) as any;

                // Exibindo a table após executar o datatables
                setTimeout(() => {
                    newDataTable.css('visibility', 'visible');
                }, 20);

                resolve(newDataTable.DataTable(options));
            }, 50);

        });
    }


    /**
     * Destroi a table para poder reexibi-la novamente em seguida
     */
    destroyTable(dataTable: any) {
        if (dataTable) {
            dataTable.destroy();
        }
    }
}
